module.exports = __webpack_public_path__ + "static/media/grid-loading-red.bf6d3d94.svg";